import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const STORAGE_KEY = "dulorme_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, "declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent-banner"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-0 inset-x-0 z-[70] border-t border-white/10 bg-[#0a0a0a]/95 backdrop-blur-xl"
        >
          <div className="container-custom py-5 flex flex-col sm:flex-row items-center gap-4 justify-between">
            <p className="text-sm text-zinc-400 leading-relaxed">
              We use cookies to improve your experience and understand how visitors use this site.
            </p>
            <div className="flex gap-3 shrink-0">
              <button
                data-testid="cookie-decline-btn"
                onClick={decline}
                className="text-xs tracking-widest uppercase text-zinc-400 hover:text-white transition-colors px-4 py-2"
              >
                Decline
              </button>
              <button
                data-testid="cookie-accept-btn"
                onClick={accept}
                className="text-xs tracking-widest uppercase bg-white text-black font-bold px-5 py-2 hover:bg-violet-500 hover:text-white transition-colors duration-300"
              >
                Accept
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
